import {
  ArrayParam,
  BooleanParam,
  DateParam,
  NumberParam,
  StringParam,
} from "use-query-params";

const GENERAL_QUERY_PARAMS = {
  orderBy: ArrayParam,
  query: StringParam,
  page: NumberParam,
  c: ArrayParam,
};

export const PROJECTS_DEFAULT_QUERY_PARAMS = {
  requestor: ArrayParam,
  projectLeaders: ArrayParam,
  projectNumber: StringParam,
  projectName: StringParam,
  projectType: ArrayParam,
  status: ArrayParam,
  productCategory: ArrayParam,
  platformProject: BooleanParam,
  intangibleAccountingStandard: BooleanParam,
  productLine0: ArrayParam,
  productLine1: ArrayParam,
  productLine2: ArrayParam,
  ...GENERAL_QUERY_PARAMS,
};

const DASHBOARD_PARAMS = {
  projectNumber: StringParam,
  projectName: StringParam,
  daysAvailable: NumberParam,
  approverName: StringParam,
};

const PENDING_APPROVAL_DASHBOARD_PARAMS = {
  dateAssigned: DateParam,
  ...GENERAL_QUERY_PARAMS,
  ...DASHBOARD_PARAMS,
};

const RECENTLY_APPROVED_DASHBOARD_PARAMS = {
  dateApproved: DateParam,
  ...GENERAL_QUERY_PARAMS,
  ...DASHBOARD_PARAMS,
};

export const PENDING_MILESTONE_APPROVAL_DASHBOARD_PARAMS = {
  ...PENDING_APPROVAL_DASHBOARD_PARAMS,
  scheduleName: StringParam,
  parentMilestone: StringParam,
  milestone: StringParam,
  functionalArea: ArrayParam,
  projectRoleName: StringParam,
};

export const RECENTLY_APPROVED_MILESTONE_DASHBOARD_PARAMS = {
  ...GENERAL_QUERY_PARAMS,
  projectNumber: StringParam,
  projectName: StringParam,
  scheduleName: StringParam,
  parentMilestoneName: StringParam,
  milestoneName: StringParam,
  dateAssigned: DateParam,
  approverName: StringParam,
  functionalArea: ArrayParam,
  projectRoleName: StringParam,
};

export const PENDING_INTAKE_APPROVAL_DASHBOARD_PARAMS = {
  ...PENDING_APPROVAL_DASHBOARD_PARAMS,
  financeApprovalGroup: ArrayParam,
  productLine0: ArrayParam,
  productLine1: ArrayParam,
  productLine2: ArrayParam,
  projectType: ArrayParam,
  productCategory: ArrayParam,
  intangibleAccountingStandard: BooleanParam,
  platformProject: BooleanParam,
  department: StringParam,
};

export const RECENTLY_APPROVED_INTAKE_DASHBOARD_PARAMS = {
  ...RECENTLY_APPROVED_DASHBOARD_PARAMS,
  financeApprovalGroup: ArrayParam,
  productLine0: ArrayParam,
  productLine1: ArrayParam,
  productLine2: ArrayParam,
  projectType: ArrayParam,
  productCategory: ArrayParam,
  intangibleAccountingStandard: BooleanParam,
  platformProject: BooleanParam,
  department: StringParam,
  approverUserName: StringParam,
};

export const USER_REPLACEMENT_DEFAULT_QUERY_PARAMS = {
  projectId: StringParam,
  projectNumber: StringParam,
  projectNumbers: ArrayParam,
  projectName: StringParam,
  projectType: ArrayParam,
  productCategory: ArrayParam,
  status: ArrayParam,
  milestone: StringParam,
  milestoneStatus: ArrayParam,
  role: ArrayParam,
  roleType: ArrayParam,
  onlySecureProjects: StringParam,
  notApplicableEligible: StringParam,
  userToBeReplaced: StringParam,
  allowBlank: StringParam,
  scheduleName: StringParam,
  ...GENERAL_QUERY_PARAMS,
};
